import ACTIONS, { FETCH_STATUS } from '../app.constants';
import { Comment, CommentList, FilterCondition, Form } from '../modules/application/types';
import { LimitAndSkipData } from '../modules/calendar/types';
import { Citation, CitationList, CitationTypeConfiguration } from '../modules/citation/types';

export const getCitations = {
    pending: {
        type: ACTIONS.GET_CITATION_LIST.PENDING,
    },
    success: (data: CitationList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.GET_CITATION_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_CITATION_LIST.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getCitationListBegin = (paginationData: LimitAndSkipData) => ({
    type: ACTIONS.GET_CITATION_LIST_BEGIN,
    status: true,
    paginationData,
});

export const getCitationListCount = {
    pending: (data: LimitAndSkipData) => ({
        type: ACTIONS.SET_CITATION_LIST_COUNT.PENDING,
        data,
        status: FETCH_STATUS.LOADING,
    }),
    success: (citationCount: number) => ({
        type: ACTIONS.SET_CITATION_LIST_COUNT.SUCCESS,
        citationCount,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error: Error) => ({
        type: ACTIONS.SET_CITATION_LIST_COUNT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getCitationDetail = {
    pending: {
        type: ACTIONS.GET_CITATION_DETAIL.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (citation: Citation, citationType: CitationTypeConfiguration, editForm: Form) => ({
        type: ACTIONS.GET_CITATION_DETAIL.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: {
            citation,
            citationType,
            editForm,
        },
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_CITATION_DETAIL.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getCitationDetailBegin = (id: string) => {
    return {
        type: ACTIONS.GET_CITATION_DETAIL_BEGIN,
        payload: { id },
    };
};

export const updateCitation = {
    pending: {
        type: ACTIONS.UPDATE_CITATION.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Citation) => ({
        type: ACTIONS.UPDATE_CITATION.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.UPDATE_CITATION.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getCitationFileList = {
    pending: {
        type: ACTIONS.GET_CITATIONS_FILE_LIST.PENDING,
    },
    success: (data: FileList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.GET_CITATIONS_FILE_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_CITATIONS_FILE_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const deleteCitationsFileDocument = {
    pending: {
        type: ACTIONS.DELETE_CITATIONS_FILE_DOCUMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (fileId: string) => ({
        type: ACTIONS.DELETE_CITATIONS_FILE_DOCUMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: { fileId },
    }),
    error: (error: Error) => ({
        type: ACTIONS.DELETE_CITATIONS_FILE_DOCUMENT.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};
export const downloadCitationsFileDocument = {
    pending: {
        type: ACTIONS.DOWNLOAD_CITATIONS_FILE_DOCUMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: {
        type: ACTIONS.DOWNLOAD_CITATIONS_FILE_DOCUMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
    },
    error: (error: Error) => ({
        type: ACTIONS.DOWNLOAD_CITATIONS_FILE_DOCUMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const updateCitationBegin = (data: Citation, citationId: string, fees: boolean) => {
    return {
        type: ACTIONS.UPDATE_CITATION_BEGIN,
        payload: { data, citationId, fees },
    };
};

export const getCitationCommentList = {
    pending: {
        type: ACTIONS.CITATION_COMMENT_LIST.PENDING,
    },
    success: (data: CommentList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.CITATION_COMMENT_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.CITATION_COMMENT_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const addCitationComment = {
    pending: {
        type: ACTIONS.ADD_CITATION_COMMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Comment) => ({
        type: ACTIONS.ADD_CITATION_COMMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_CITATION_COMMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getCitationCommentListBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.CITATION_COMMENT_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};
export const getCitationsFileListBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_CITATIONS_FILE_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};

export const addCitationCommentBegin = (data: string, citationId: string) => {
    return {
        type: ACTIONS.ADD_CITATION_COMMENT_BEGIN,
        payload: { data, citationId },
    };
};
export const downloadCitationsFileDocumentBegin = (citationId: string, fileId: string, fileName: string) => {
    return {
        type: ACTIONS.DOWNLOAD_CITATIONS_FILE_DOCUMENT_BEGIN,
        payload: { citationId, fileId, fileName },
    };
};
export const deleteCitationsFileDocumentBegin = (citationId: string, fileId: string) => {
    return {
        type: ACTIONS.DELETE_CITATIONS_FILE_DOCUMENT_BEGIN,
        payload: { citationId, fileId },
    };
};

export const getCitationSearchForm = {
    pending: {
        type: ACTIONS.GET_CITATION_SEARCH_FORM.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (searchForm: Form) => ({
        type: ACTIONS.GET_CITATION_SEARCH_FORM.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: searchForm,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_CITATION_SEARCH_FORM.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getCitationSearchConfiguredFormBegin = () => {
    return {
        type: ACTIONS.GET_CITATION_SEARCH_FORM_BEGIN,
    };
};

export const setCitationFilterSelections = (data: Record<string, string | string[]>) => {
    return {
        type: ACTIONS.CHANGE_CITATION_FILTERS,
        payload: { data },
    };
};

export const applyCitationFilters = (data: FilterCondition[], paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.APPLY_CITATION_FILTERS,
        payload: { data },
        data: paginationData,
    };
};
